// validation.js
import { isValid, parse } from 'date-fns'

/**
 * 日付入力欄の手入力テキストを検証する
 *
 * 「yyyy/MM/dd」形式でパースし、年度期間（minDate〜maxDate）内かを判定する。 パース不能な文字列は範囲外と同じ扱い（isValid: false）とする。
 *
 * @param {string} rawText - 入力欄の生テキスト
 * @param {Date | null} minDate - 年度期間の開始日
 * @param {Date | null} maxDate - 年度期間の終了日
 * @returns {{ isEmpty: boolean; isValid: boolean; date: Date | null }} 検証結果
 */
export const validateFiscalDateInput = (rawText, minDate, maxDate) => {
  const text = (rawText || '').trim()
  if (text === '') {
    return { isEmpty: true, isValid: false, date: null }
  }

  const parsed = parse(text, 'yyyy/MM/dd', new Date())
  if (!isValid(parsed)) {
    return { isEmpty: false, isValid: false, date: null }
  }

  const isInRange = (!minDate || parsed >= minDate) && (!maxDate || parsed <= maxDate)
  return { isEmpty: false, isValid: isInRange, date: isInRange ? parsed : null }
}
